var React = require('react');

function RoundAlert (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M30.5 31C50.833 10.667 75.333.5 104 .5s53.167 10.167 73.5 30.5S208 75.833 208 104.5s-10.167 53.167-30.5 73.5-44.833 30.5-73.5 30.5-53.167-10.167-73.5-30.5S0 133.167 0 104.5 10.167 51.333 30.5 31zM116 156.5v-20H92v20h24zm0-44v-64H92v64h24z","fill":"#000"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 .5h208v208H0z"})))]);
}

RoundAlert.defaultProps = {"fill":"none","viewBox":"0 0 208 209"};

module.exports = RoundAlert;

RoundAlert.default = RoundAlert;
